import React, { EventHandler, ReactElement } from 'react';
import { iconFiles } from '../../atoms/Icon/files';
import { Submenu } from './Submenu';

export interface MenuEntry {
  title: string;
  /** The left icon of the menu item */
  icon?: keyof typeof iconFiles;
  /** The right icon or passed component of the menu item */
  rightIcon?: keyof typeof iconFiles | ReactElement;
  /** Keyboard shortcut for a menu item */
  shortCut?: string; // TODO: make the format the same as `ContextMenuListItem`
  visible?: boolean;
  disabled?: boolean;
  disabledReason?: string;
  /** The subitems of a menu item */
  children?: MenuConfig;
  /** True if the entry is a divider */
  isDivider?: boolean;
  /** Allows passing custom menus (for example:`QuickTags`) */
  // TODO: maybe find a different way to render `QuickTags`?
  //component?: (closeFn: Function, isOpen: boolean) => JSX.Element;
  /** Click handler for each menu item */
  onClick?: EventHandler<React.MouseEvent>;
}
export interface MenuGroup {
  groupName?: string;
  entries: MenuEntry[];
}

export type MenuConfig = Array<MenuEntry | MenuGroup>;

/** type guards */

export const isMenuEntry = (variableToCheck): variableToCheck is MenuEntry =>
  (variableToCheck as MenuEntry).title !== undefined;

export const isMenuGroup = (variableToCheck): variableToCheck is MenuGroup =>
  (variableToCheck as MenuGroup).entries !== undefined;

interface Props {
  anchor: HTMLElement;
  menuConfig: MenuConfig;
  open: boolean;
  onClose: () => void;
}
/** Recursively render menus by a given trigger element
 */
export const NestedMenu = (props: Props) => {
  const { menuConfig, open, anchor, onClose } = props;

  return (
    <>
      {open && (
        <Submenu
          menuConfig={menuConfig}
          anchor={anchor}
          onClose={onClose}
          placement="bottom-start"
          offset={8}
          scrollbarHeight={500}
        />
      )}
    </>
  );
};
